import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { BRAND, OFFER_ANCHOR, PACK_IMAGE, PRODUCT } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="bg-cream" data-id="element-108" data-mp="4lyuukqi8cd4">
      <div className="bg-ink" data-id="element-109" data-mp="4mrxpamcehpz">
        <p className="mx-auto max-w-page px-3 py-1 text-center text-[0.58rem] font-extrabold uppercase tracking-[0.28em] text-gold sm:text-[0.7rem]" data-id="element-110" data-mp="4jm53lei8xpi">
          {BRAND}
        </p>
      </div>

      <div className="mx-auto flex max-w-page flex-col items-center px-3 pb-5 pt-3 text-center sm:px-6 sm:pb-6" data-id="element-111" data-mp="xb5rfe6eervq">
        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE
      }} className="max-w-4xl font-display text-[1.3rem] font-black uppercase leading-[1.05] text-ink sm:text-3xl lg:text-[2.7rem]" data-id="element-112" data-mp="sd4b310cx6ny">
          Aprende coreano <span className="text-coral" data-id="element-113" data-mp="3j8iwex8gcctn">desde cero</span>, paso a
          paso
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE,
        delay: 0.05
      }} className="mt-1.5 max-w-2xl text-[0.8rem] font-bold leading-snug text-ink-soft sm:text-sm" data-id="element-114" data-mp="3o7lprkf2kuls">
          Deja de perderte entre videos, apps y vocabulario suelto. Sigue un
          sistema claro, visual y práctico.
        </motion.p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.09
      }} className="mt-2.5 block w-full max-w-xl" data-id="element-115" data-mp="3599f1u8ifco3">
          <img src={PACK_IMAGE} alt={`${PRODUCT}: 6 tomos digitales y 5 bonos incluidos`} className="mx-auto w-full rounded-xl border-2 border-blush shadow-[0_10px_30px_rgba(20,33,61,0.12)]" data-id="element-116" data-mp="2vglpnkjv0aze" />
        </motion.a>

        <p className="mx-auto mt-2.5 max-w-3xl font-body text-[0.78rem] leading-snug text-slate sm:text-sm" data-id="element-117" data-mp="s2tdvmncibq9">
          Con <span className="font-bold text-ink" data-id="element-118" data-mp="na08qxnyt1dn">{PRODUCT}</span> aprenderás a
          comprender Hangul, mejorar tu pronunciación, reconocer vocabulario
          esencial, construir tus primeras frases, comunicarte en situaciones
          cotidianas y empezar a entender expresiones frecuentes del coreano.{' '}
          <span className="font-bold text-coral" data-id="element-119" data-mp="1ayt6mzo5djaw">
            Incluso si hoy estás comenzando desde cero.
          </span>
        </p>

        <div className="mt-3 flex w-full flex-col items-center gap-1.5" data-id="element-120" data-mp="1126oiin7h6ck">
          <CtaButton size="lg" data-id="element-121" data-mp="114kfogerlyeu">
            ¡SÍ! QUIERO APRENDER COREANO DESDE CERO
          </CtaButton>
          <p className="flex items-center gap-1.5 text-[0.68rem] font-bold uppercase tracking-wide text-slate sm:text-xs" data-id="element-122" data-mp="3lsyu93l8eul6">
            <ShieldCheckIcon size={14} className="text-gold" data-id="element-123" data-mp="3hr3tc077qj7x" />
            🛡️ Garantía de Devolución de 30 Días
          </p>
        </div>
      </div>
    </header>;
}